import clsx from "clsx";
import React from "react";
import { ListItemButton, ListItemButtonProps } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDrawer } from "../../hooks/useDrawer";
import { navItemListItemStyles } from "../item/NavItemStyles";

export interface LibraryNavItemListItemProps extends ListItemButtonProps {
  link: string;
  name: string;
  IconComponent: React.ComponentType<any>;
}

export function LibraryNavItemListItem(props: LibraryNavItemListItemProps) {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useDrawer();
  const { className, link, name, IconComponent, ...other } = props;
  const s = navItemListItemStyles();
  const location = useLocation();
  const active = location.pathname.includes(link);

  const handleClick = React.useCallback(() => {
    navigate(link);
    setDrawerOpen(false);
  }, [link]);

  return (
    <ListItemButton
      className={clsx(s.root, className, active && s.active)}
      onClick={handleClick}
      {...other}
    >
      <IconComponent className={s.icon} />
      <span>{name}</span>
    </ListItemButton>
  );
}
